import { Link } from 'react-router-dom';

import { environmentTypes, environmentName } from "../settings/config";

import store from '../../redux/store';
import { actions } from '../../redux/actions';

const imagesBasePath = `${process.env.PUBLIC_URL}/static/images`;

export const RenderAppLogo = () => {
    let src = imagesBasePath + '/Logo_with_title.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo_with_title.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo_with_title.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.gif';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo_with_title.png';
    }

    return (
        <div className='d-flex align-items-center justify-content-center pt-5 logo-img logo' style={{ width: "50%" }}>
            <img src={src} alt="logo"/>
        </div>
    )
};

export const RenderHeaderAppLogo = ({ isSidebarOpen }) => {
    let src = imagesBasePath + '/Logo_with_title.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo_with_title.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo_with_title.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.gif';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo_with_title.png';
    }
    return (
        <div className='logo-box'>
            <Link className="d-none d-lg-flex" to="/">
                <img src={src} alt="logo" />
            </Link>
            <i className={`d-flex d-lg-none ${isSidebarOpen ? 'fas fa-times': 'fa fa-bars'} d-flex justify-content-center`}  onClick={() => { store.dispatch(actions.setSideBar(true)); }}></i>
        </div>
    )
};

export const RenderHeaderText = () => {
    return (
        <div className='header-text'>
            <div className='text-primary text-2l' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                <Link to="/">AssessMax<span className='text-secondary'>{environmentName === environmentTypes.YI ? '360' : 'Edu'}</span></Link>
            </div>
        </div>
    );
};

export const RenderNoAuthHeaderText = () => {
    return (
        <div className='heading'>AssessMax<span className='text-secondary'>{environmentName === environmentTypes.YI ? '360' : 'Edu'}</span><span className='px-2'>👋</span></div>
    );
};

export const ProfileAvatar = () => {
    let src = imagesBasePath + '/Logo_only.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.png';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo.png';
    }
    return <img role='button' className='profile-avatar' src={src} alt="profile"  />;
}